<template>
  <div id="search">
    <p class="title">协议库上传</p>

    <!-- 添加编辑 -->
    <el-dialog
      :title="editType == 1 ? '添加' : '编辑'"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        ref="editForm"
        :rules="editRules"
      >
        <el-row v-if="editType != 1">
          <el-form-item
            label="模板编码"
            prop="ProtocolID"
          >
            <el-input
              v-model="editForm.ProtocolCode"
              autocomplete="off"
              disabled
              placeholder="请输入模板编码"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="公司名称"
            prop="CompID"
          >
            <el-select
              style="width:100%;"
              v-model="editForm.CompID"
              placeholder="请选择"
            >
              <el-option
                v-for="item in CompanyList"
                :key="item.CompValue"
                :label="item.CompName"
                :value="item.CompID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="型号编码"
            prop="ProtocolModel"
          >
            <el-input
              v-model="editForm.ProtocolModel"
              autocomplete="off"
              placeholder="请输入型号编码"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="协议类型"
            prop="ProtocolType"
            class="formItem"
          >
            <el-select
              style="width:100%;"
              v-model="editForm.ProtocolType"
              placeholder="请选择协议类型"
            >
              <el-option
                v-for="item in dictOptions"
                :key="item.DicValue"
                :label="item.DicName"
                :value="item.DicID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="规格标识"
            class="formItem"
            prop="ProtocolSpec"
          >
            <el-select
              style="width:100%;"
              v-model="editForm.ProtocolSpec"
              placeholder="请选择规格标识"
            >
              <el-option
                v-for="item in Spec"
                :key="item.DicValue"
                :label="item.DicName"
                :value="item.DicID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="模板名称">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入模板名称"
              v-model="editForm.ProtocolName"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="适用型号">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入适用型号"
              v-model="editForm.ProductUse"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注说明">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注说明"
              v-model="editForm.Remark"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('editForm')"
          :loading="sumbitLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="tableBox">
      <div class="leftBox">
        <el-button
          icon="el-icon-plus"
          @click="add"
        >添加</el-button>
      </div>
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#2c86d1',
          color: 'white',
          textAlign: 'center',
        }"
        :cell-style="{ textAlign: 'center' }"
        v-loading="table.loading"
      >
        <el-table-column
          prop="ProtocolCode"
          label="模板编码"
          width="240"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="ProtocolName"
          label="名称"
          :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="CompName"
          label="公司名称"
          width="220"
          :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="ProductUse"
          label="适用型号"
          :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="Remark"
          label="模板说明"
          :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="CreateUserName"
          label="制作者"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="UpdateTime"
          label="更新时间"
          width="200"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="edit(scope.row)"
            >修改</el-button>

            <el-button
              size="mini"
              type="primary"
              @click="upload(scope.row.ProtocolID)"
            >上传</el-button>

            <el-button
              size="mini"
              type="warning"
              @click="handleConfig(scope.row)"
            >配置模板</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 配置协议 -->
    <el-dialog
      :title="modalTitle"
      :visible.sync="configFlag"
      top="6vh"
      width="95%"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="遥测点表"
          name="second"
        >
          <Telemetry
            :item="TempVerID"
            :power="power"
            :Value="Value"
            :key="activeName"
          />
        </el-tab-pane>
        <el-tab-pane
          label="遥信点表"
          name="first"
        >
          <Remote
            :item="TempVerID"
            :power="power"
            :Value="Value"
            :key="activeName"
          />
        </el-tab-pane>
        <el-tab-pane
          label="遥控点表"
          name="three"
        >
          <Telecontrol
            :item="TempVerID"
            :power="power"
            :Value="Value"
            :key="activeName"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getParams } from "@/utils/common";
import Telemetry from "../protocol/component/Telemetry";
import Remote from "../protocol/component/remote";
import Telecontrol from "../protocol/component/telecontrol";
export default {
  components: {
    Telemetry,
    Remote,
    Telecontrol,
  },
  data() {
    return {
      editType: 1, //1添加2编辑
      editFormVisible: false,
      editForm: {},
      editRules: {
        CompID: [
          {
            required: true,
            message: "请选择公司名称",
            trigger: "change",
          },
        ],
        ProtocolModel: [
          {
            required: true,
            message: "请输入型号编码",
            trigger: "change",
          },
        ],
        ProtocolType: [
          {
            required: true,
            message: "请选择协议类型",
            trigger: "change",
          },
        ],
        ProtocolSpec: [
          {
            required: true,
            message: "请选择规格标识",
            trigger: "change",
          },
        ],
      },
      CompanyList: [], //公司列表
      dictOptions: [], //获取数据字典
      Spec: [], //规格标识
      loginLoading: false,
      sumbitLoading: false,
      modalTitle: "", //配置协议
      TempVerID: "",
      power: "",
      configFlag: false,
      activeName: "second",
      searchForm: {},
      table: {
        data: [],
        loading: false,
      },
      Value: {
        SessionId: getParams("SessionId"),
        UserId: getParams("UserId"),
        ClientName: "Hoko.Iot.Web.",
      },
    };
  },
  computed: {
    ...mapGetters(["SessionId", "UserId"]),
  },
  methods: {
    async upload(ProtocolID) {
      this.$messageBox
        .confirm("确定将所选的配置表作为模板上传吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          window.parent.postMessage(
            {
              type: "ProtocolID",
              code: "success",
              data: ProtocolID,
            },
            "*"
          );
        })
        .catch(() => {});
    },
    async getList() {
      this.table.loading = true;
      let obj = {
        SessionId: getParams("SessionId"),
        UserId: getParams("UserId"),
        ClientName: "Hoko.Iot.Web.",
        Params: {},
      };
      // if (searchValue) {
      //   obj.Params.SearchValue = this.searchForm.searchValue;
      // }
      const res = await this.$api.axios_http(this.$gd.GetListSelf, obj, "POST");
      this.table.loading = false;
      if (res && res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.UpdateTime) {
              item.UpdateTime = this.$moment(item.UpdateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.table.data = res.ReturnList;
      } else {
        window.parent.postMessage(
          {
            type: "errLogin",
            code: "error",
            data: "登录态失效",
          },
          "*"
        );
      }
    },
    async search() {
      this.getList(this.searchForm.searchValue);
      // window.parent.postMessage(
      //   {
      //     data: {
      //       code: "success",
      //       test: `我是子页面数据${this.searchForm.searchValue}`,
      //     },
      //   },
      //   "*"
      // );
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "editForm") {
            this.sumbit();
          }
        } else {
          return false;
        }
      });
    },
    async sumbit() {
      this.sumbitLoading = true;
      let obj = {
        SessionId: getParams("SessionId"),
        UserId: getParams("UserId"),
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.editForm },
      };
      //添加
      let res;
      if (this.editType === 1) {
        res = await this.$api.axios_http(
          this.$gd.admin.template.add,
          obj,
          "POST"
        );
      } else {
        res = await this.$api.axios_http(
          this.$gd.admin.template.edit,
          obj,
          "POST"
        );
      }
      this.sumbitLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.editFormVisible = false;
        if (this.editType === 1) {
          this.table.pageNum = 1;
          this.table.pageSize = 15;
        }
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    // 表单重置
    reset() {
      this.editForm = {
        CompID: null,
        ProtocolModel: null,
        ProtocolType: null,
        ProtocolSpec: null,
        ProtocolName: null,
        ProductUse: null,
        Remark: null,
      };
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    // 添加
    add() {
      this.reset();
      this.editType = 1;
      this.editFormVisible = true;
    },
    edit(data) {
      //编辑
      this.reset();
      this.editForm = JSON.parse(JSON.stringify(data));
      this.editType = 2;
      this.editFormVisible = true;
    },
    getDict(DicID) {
      // 获取数据字典   协议类型
      let obj = {
        Params:{
           DicID:DicID
        }
      };

      return new Promise((resolve) => {
        this.$api.axios_http(this.$gd.GetDict, obj, "POST").then((res) => {
          if (res.ReturnCode == 0) {
            if (res.ReturnList && res.ReturnList.length > 0) {
              this.dictOptions = res.ReturnList;
            }
            resolve();
          } else {
            this.$message.error(res.Error);
          }
        });
      });
    },
    getDict1(DicID) {
      // 获取数据字典   规格标识
      let obj = {
        Params:{
           DicID:DicID
        }
      };
      return new Promise((resolve) => {
        this.$api.axios_http(this.$gd.GetDict, obj, "POST").then((res) => {
          if (res.ReturnCode == 0) {
            if (res.ReturnList && res.ReturnList.length > 0) {
              this.Spec = res.ReturnList;
            }
            resolve();
          } else {
            this.$message.error(res.Error);
          }
        });
      });
    },
    async Company() {
      let obj = {
        SessionId: getParams("SessionId"),
        UserId: getParams("UserId"),
        ClientName: "Hoko.Iot.Web.",
        Params: {
          PageNumber: this.table.pageNum,
          PageSize: this.table.pageSize,
          SearchList: [],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.vender.getList,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          let List = [];
          res.ReturnList.forEach((item, index) => {
            List.push({
              CompName: item.CompName,
              CompCode: item.CompCode,
              CompID: item.CompID,
              CompValue: index,
            });
          });
          this.CompanyList = List;
        }
        // this.table.total = res.RecordCount;
        // this.table.data = res.ReturnList;
      } else {
        this.$message.error(res.Error);
      }
    },
    handleClickMessage(event) {
      const data = event.data;
      console.log(data);
    },
    // 配置模板
    handleConfig(item) {
      this.modalTitle = "点表配置";
      this.configFlag = true;
      // 传给子界面的参数
      this.TempVerID = item.ProtocolID;
      this.power = item.Status;
    },
  },
  mounted() {
    this.getList();
    window.addEventListener("message", this.handleClickMessage);
    this.getDict("025");
    this.getDict1("024");
    this.Company();
  },
};
</script>
<style lang="scss" scoped>
#search {
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  overflow: hidden;
  .title {
    font-size: 28px;
    margin: 0;
    margin-bottom: 22px;
  }
  .tableBox {
    flex: 1;
    width: 100%;
    .leftBox {
      text-align: right;
      padding-bottom: 10px;
    }
  }
}
</style>
